var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPickerEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "300px",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "picker empty") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "169.961462%",
    y1: "-324.053889%",
    x2: "38.5316377%",
    y2: "125.542689%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44C0FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9F9F0",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "resized-illustrations_version-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "picker-empty"
  }, /*#__PURE__*/React.createElement("g", {
    id: "error-msg"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    x: 0,
    y: 0,
    width: 300,
    height: 300
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.254584,151.741573 C264.589504,212.19705 215.411011,261 154.842324,261 C93.8595457,261 44.4232365,211.527465 44.4232365,150.5 C44.4232365,145.447329 44.7621099,140.473863 45.4183532,135.601124 L10.9325843,135.601124 C5.44696945,135.601124 1,131.154154 1,125.668539 C1,120.182925 5.44696945,115.735955 10.9325843,115.735955 L49.9985591,115.735955 L89.0798639,115.735955 C94.5654787,115.735955 99.0124481,111.288986 99.0124481,105.803371 C99.0124481,101.536153 96.3215139,97.8974372 92.543996,96.491573 C91.4654202,96.8929824 90.2982612,97.1123596 89.0798639,97.1123596 L43.1898457,97.1123596 C37.7042309,97.1123596 33.2572614,92.6653901 33.2572614,87.1797753 C33.2572614,81.6941605 37.7042309,77.247191 43.1898457,77.247191 L72.1710885,77.247191 C92.4001989,54.4006708 121.940764,40 154.842324,40 C202.299058,40 242.763324,69.9602512 258.37869,112.011236 L290.067416,112.011236 C295.553031,112.011236 300,116.458205 300,121.94382 C300,127.429435 295.553031,131.876404 290.067416,131.876404 L263.699818,131.876404 L241.69607,131.876404 C236.210455,131.876404 231.763485,136.323374 231.763485,141.808989 C231.763485,147.294604 236.210455,151.741573 241.69607,151.741573 L265.254584,151.741573 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(139.376653, 154.761917) rotate(-1.000000) translate(-139.376653, -154.761917) translate(66.376653, 72.261917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(73.251942, 82.425047) rotate(-29.000000) translate(-73.251942, -82.425047) translate(28.751942, 13.425047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(33.072433, 39.157389)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-28",
    stroke: "#80959D",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 46.0138201,
    height: 40.4962756
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-28-Copy",
    fill: "#87D5FA",
    points: "7.1896594 5.78518223 45.3024742 6.13942646 45.3024742 40.0707745 7.1896594 39.7165303"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-29",
    stroke: "#80959D",
    fill: "#FFFFFF",
    x: 23.0069101,
    y: 15.9092511,
    width: 17.2551826,
    height: 13.01666
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-13-Copy",
    transform: "translate(33.072433, 82.546256)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-28",
    stroke: "#80959D",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 54.6414114,
    height: 47.7277534
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-28-Copy",
    fill: "#EB8181",
    points: "7.1896594 5.78518223 54.1153708 5.31923114 54.1153708 47.2618023 7.97435467 47.1803866"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-29",
    stroke: "#80959D",
    fill: "#FFFFFF",
    x: 34.5103651,
    y: 5.78518223,
    width: 12.9413869,
    height: 18.8018422
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.8229997,4.26325641e-14 C24.1670213,0.102535391 27.8390322,3.92332893 27.8390322,11.4623806 C27.8390322,19.0014323 27.8390322,49.591242 27.8390322,103.23181",
    id: "Path-13",
    stroke: "#80959D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(0.540865, 105.029746)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    stroke: "#80959D",
    fill: "#FFFFFF",
    cx: 14.3793188,
    cy: 14.4629556,
    rx: 14.3793188,
    ry: 14.4629556
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5-Copy",
    fill: "#87D5FA",
    cx: 14.3793188,
    cy: 14.4629556,
    rx: 8.62759128,
    ry: 8.67777334
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-14",
    stroke: "#80959D",
    points: "27.4091922 132.77263 27.4091922 137.101749 48.6824864 137.101749"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickerEmpty);
export default __webpack_public_path__ + "static/media/picker-empty.a0eafb2166eed85a512157d349144e0c.svg";
export { ForwardRef as ReactComponent };